// extracted by mini-css-extract-plugin
export default {"stepPage":"Register_stepPage__wJVf6","row":"Register_row__nFlx9","nextButton":"Register_nextButton__FFOAX"};